import { STORAGE } from '../enums/storage';
export var LIB_KEY = 'ng2-webstorage';
export var LIB_KEY_SEPARATOR = '|';
export var LIB_KEY_CASE_SENSITIVE = false;
export var STORAGE_NAMES = (_a = {},
    _a[STORAGE.local] = 'local',
    _a[STORAGE.session] = 'session',
    _a);
var _a;
//# sourceMappingURL=lib.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-webstorage/dist/constants/lib.js
// module id = ../../../../ngx-webstorage/dist/constants/lib.js
// module chunks = 15